import React from 'react'
import { browserHistory } from 'react-router'
import common from '../Common/Common.scss'
import Friends from './Friends'
import AddFriends from './AddFriends'

class FriendsList extends React.Component {

  constructor (props) {
    super(props)
  }

  componentWillMount () {
    window.scrollTo(0, 0)
  }

  setView (name) {
    const { toggleSidebar } = this.props
    browserHistory.push('/friends/new')
    toggleSidebar(false)
  }

  render () {
    const { baseUrl, username, openViewRequestModal, viewRequestModal, closeViewRequestModal, friendList, setFriendList } = this.props
    console.log('friendlist', friendList)
    return (
      <div className={common.gameList}>
        <ul className={common.gameTabs}>
          <li onClick={() => browserHistory.push('/friends')} className={friendList === 'friends' && common.active}>Friends</li>
          <li onClick={() => browserHistory.push('/friends/new')} className={friendList === 'add_new' && common.active}>Add Friends</li>
        </ul>
        {friendList === 'friends' && <Friends baseUrl={baseUrl} openViewRequestModal={openViewRequestModal} viewRequestModal={viewRequestModal} closeViewRequestModal={closeViewRequestModal} />}
        {friendList === 'add_new' && <AddFriends baseUrl={baseUrl} openViewRequestModal={openViewRequestModal} />}
      </div>
    )
  }
}

export default FriendsList



/** WEBPACK FOOTER **
 ** ./src/components/Friends/FriendsList.js
 **/